<template>
    <div class="fixed z-50 pin overflow-auto bg-modal" :class="active ? 'block' : 'hidden'" v-if="invitation">
        <div class="shadow max-w-sm mx-auto mt-24 px-4 md:px-0">
            <div class="bg-white rounded-t p-6">
                <div class="text-center text-grey-dark leading-normal">
                    {{ $t('Are_you_sure_to_decline_this_appointment_') }}
                </div>
            </div>
            <div class="flex border-t items-center">
                <button @click="close" class="block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black">
                    {{ $t('Cancel') }}
                </button>
                <button @click.prevent="decline" class="block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-blue">
                    {{ $t('Yes_decline') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import helpers from '@/mixins/helpers'

export default {
    name: 'decline-invitation-modal',

    props: ['active', 'invitation'],

    mixins: [helpers],

    methods: {
        close () {
            this.$emit('close')
        },

        decline () {
            this.$emit('declined')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Patient/DeclineInvitationModal.vue